import * as React from "react";
import { getMonthYearName, getLocalizedText } from "../util";
import type { LocalizedOrString } from "../../types/data";
import { useLang } from "../lang";
import { useReadMore } from "../hooks/useReadMore";

type ListupItem = {
  month?: number;
  year?: number;
  name: LocalizedOrString;
  url?: LocalizedOrString;
};

type ListupProps = {
  items: ListupItem[];
  title_en: string;
  title_ja: string;
  item_nums?: number;
};

const Listup: React.FC<ListupProps> = ({ items, title_en, title_ja, item_nums }) => {
  const { langEn } = useLang();
  const { expanded, toggle, isVisible, showToggle } = useReadMore(item_nums);

  return (
    <div className="col-md-12 mb-2">
      <p className="sub-title">{langEn ? title_en : title_ja}</p>
      <ul className="mb-0">
        {items
          .filter((item, i) => isVisible(i))
          .map((item, i) => (
            <li key={i}>
              {item.month ? (
                <span className="date"> {getMonthYearName(item.month, item.year, langEn)}:</span>
              ) : (
                ""
              )}
              {getLocalizedText(item.name, langEn)}
              {item.url ? (
                <a href={getLocalizedText(item.url, langEn)} className="ml-2 icon-link"></a>
              ) : (
                ""
              )}
            </li>
          ))}
        {showToggle && !expanded ? (
          <a
            href=""
            className=""
            onClick={(e) => {
              e.preventDefault();
              toggle();
            }}
          >
            more &raquo;
          </a>
        ) : (
          ""
        )}
        {showToggle && expanded ? (
          <a
            href=""
            onClick={(e) => {
              e.preventDefault();
              toggle();
            }}
          >
            &laquo; close
          </a>
        ) : (
          ""
        )}
      </ul>
    </div>
  );
};

export default Listup;
